<template>
    <div class="breadCrumpWrap">
        <span class="backBtn" v-if="isShowBack" @click="backPage"> <i class="el-icon-arrow-left"></i> 返回</span>
        <div class="itemBox">
            <span v-for="(breadList,index) in breadData">
                <span @click="clickBreadSpan(breadList,index)" class="name" :class="{active:breadList.isCurrent,disabled:index==0}">{{breadList.text}}</span>
                <span v-if="index!=breadData.length-1" class="lineIcon">></span>
            </span>

        </div>

    </div>
</template>

<script>
    // import {json,wordData,utils} from '@/common/common.js'
    export default {
        name: 'HelloWorld',
        props: ['isShowBack', "breadData"],
        data() {
            return {
                msg: 'Welcome to Your Vue.js App'
            }
        },
        methods: {
            backPage() {
                this.$router.back()
            },
            clickBreadSpan(list,index){
               if(index==0){
                   return false
               }else{
                   this.$router.push(list.path)
               }
               
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .breadCrumpWrap {
        display: flex;
        font-size: 12px;
        background: #f7f7f7;
        border-bottom: 1px solid #dedede;
        box-shadow: 0 0 4px #eee;
        color: #606266;
        padding: 10px 20px 8px;

        .backBtn {
            color: #333;
            border: 1px solid #ddd;
            font-size: 12px;
            border-radius: 4px;
            padding: 3px 5px;
            cursor: pointer;
            background: #fff;
            margin-right: 20px;
            display: inline-block;
            vertical-align: text-bottom;
        }

        .backBtn:hover {
            background: #ddc
        }

        .itemBox {
            line-height: 24px;
            .name:hover,.name.active{color:royalblue;cursor: pointer}
            .disabled.name{color:#999}
            .disabled.name:hover{cursor:not-allowed}
        }
        .lineIcon{padding:0 3px;}
    }
</style>



// WEBPACK FOOTER //
// src/components/breadCrump.vue